export type LocationInfo = {
  city: string | null
  state: string | null
  country: string | null
}

export async function getNearestLocation(
  lat: number,
  lon: number
): Promise<LocationInfo | null> {
  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json&zoom=10&addressdetails=1`
    )

    const data = await res.json()
    const address = data.address || {}

    return {
      city: address.city || address.town || address.village || null,
      state: address.state || null,
      country: address.country || null,
    }
  } catch (err) {
    console.error('Reverse geocoding failed', err)
    return null
  }
}
